import React from 'react'
import { EmptyStateSize } from 'shared/timber/v1/EmptyState'

import './Title.scss'
import classy from 'shared/utils/classy'

export interface EmptyStateTitleProps {
  size?: EmptyStateSize
  children: React.ReactNode
  appearance?: 'condensed' | 'default'
  'data-testid'?: string
}

const EmptyStateTitle = React.memo(
  ({
    size = 'md',
    children,
    appearance,
    'data-testid': dataTestId = 'empty-state-title',
  }: EmptyStateTitleProps) => {
    return (
      <h3
        className={classy(
          'EmptyStateTitle',
          `EmptyStateTitle--${size}`,
          `EmptyStateTitle--${appearance}`,
        )}
        data-appearance={appearance}
        data-testid={dataTestId}
      >
        {children}
      </h3>
    )
  },
)

EmptyStateTitle.displayName = 'EmptyState.Title'

export default EmptyStateTitle
